var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(_vm.style),attrs:{"id":"loading"}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"loading-center"}},[_c('h1',{staticClass:"text-primary text-center",staticStyle:{"font-size":"70px","font-weight":"600","margin-top":"23%"}},[_vm._v(" Auditor ")])])
}]

export { render, staticRenderFns }